




















import { Vue } from "vue-property-decorator";
import Registration from "@/views/invest/form/registration.vue"
import Cooperation from "@/views/invest/form/cooperation.vue"
import Appointment from "@/views/invest/form/appointment.vue"
import Qualification from "@/views/invest/form/qualification.vue"
import StadiumGround from "@/views/invest/form/stadium_ground.vue"
import StadiumPhoto from "@/views/invest/form/stadium_photo.vue"
import Discount from "@/views/invest/form/discount.vue"
import Rebate from "@/views/invest/form/rebate.vue"

export default Vue.extend({
  name: "StadiumCooperationInfo",
  components: {
    Registration,
    Cooperation,
    Appointment,
    Qualification,
    StadiumGround,
    StadiumPhoto,
    Discount,
    Rebate,
  },
  props: {
    id: { type: String, default: "" },
  },
  data() {
    return {
      stadium: {
        id            : "",
        name          : "",
        status        : "",
        status_logs   : [],
        estimate_logs : [],
        confirm_status: "0"
      } as any,
      confirm_status: [
        { value: 0, label: "未开始", status: "#f60" },
        { value: 1, label: "审核中", status: "#10aeff" },
        { value: 2, label: "已通过", status: "#4cd964" },
        { value: 3, label: "未通过", status: "#f6383a" },
        { value: 4, label: "已终止", status: "#D9D9D9" }
      ],
      editable        : false,
    }
  },
  methods: {
    async get_info() {
      const params = { estimate_id: this.id }
      const res = await this.$store.dispatch("invest/stadium_info", params);
      if (res.Code == 200) {
        const data = res.Data
        this.stadium = data
        this.handleRegistration(data.cooperate_info)
        this.handleCooperation(data.cooperate_info)
        this.handleAppointment(data.cooperate_info)
        this.handleQualification(data.cooperate_info)
        this.handleStadiumGround(data.cooperate_info)
        this.handleStadiumPhoto(data.cooperate_info)
        this.handleDiscount(data.cooperate_info)
        this.handleRebate(data.cooperate_info)
      }
    },
    handleRegistration(data: any) {
      const registration = this.$refs.registration as any
      registration.init(data)
    },
    handleCooperation(data: any) {
      const cooperation = this.$refs.cooperation as any
      cooperation.init(data)
    },
    handleAppointment(data: any) {
      const appointment = this.$refs.appointment as any
      appointment.init(data)
    },
    handleQualification(data: any) {
      const qualification = this.$refs.qualification as any
      qualification.init(data)
    },
    handleStadiumGround(data: any) {
      const stadium_ground = this.$refs.stadium_ground as any
      stadium_ground.init(data)
    },
    handleStadiumPhoto(data: any) {
      const stadium_photo = this.$refs.stadium_photo as any
      stadium_photo.init(data)
    },
    handleDiscount(data: any) {
      const discount = this.$refs.discount as any
      discount.init(data)
    },
    handleRebate(data: any) {
      const rebate = this.$refs.rebate as any
      rebate.init(data)
    },
    async save(params: any) {
      const res = await this.$store.dispatch("invest/save_stadium", params);
      if (res.Code == 200) {
        this.$success({
          content: "保存成功",
        })
      } else {
        this.$error({
          content: res.Message,
        })
      }
    },
    /* 提交审核 */
    submit() {
      if (this.stadium.is_confirm != 1) {
        this.$info({ content: "馆长尚未确认合作，无法提交审核" })
        return
      }
      const registration = this.$refs.registration as  any
      if (!registration.check()) {
        this.$info({ content: "信息未完整，无法提交" })
        return
      }
      const cooperation = this.$refs.cooperation as  any
      if (!cooperation.check()) {
        this.$info({ content: "请上传AI智慧场馆合作协议" })
        return
      }
      const appointment = this.$refs.appointment as  any
      if (!appointment.check()) {
        this.$info({ content: "请上传收益与费用约定表" })
        return
      }
      const qualification = this.$refs.qualification as  any
      if (!qualification.check()) {
        this.$info({ content: "信息未完整，无法提交" })
        return
      }
      const stadium_ground = this.$refs.stadium_ground as  any
      if (!stadium_ground.check()) {
        this.$info({ content: "信息未完整，无法提交" })
        return
      }
      const stadium_photo = this.$refs.stadium_photo as  any
      if (!stadium_photo.check()) {
        this.$info({ content: "信息未完整，无法提交" })
        return
      }
      this.$emit("submit", 1)
    },
    close() {
      return false
    }
  },

  watch: {
    id(id: string) {
      if (id != "0") {
        this.$nextTick(() => {
          this.get_info();
        })
      }
    }
  }
})

